import React from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { TimerPicker } from './TimerPicker';
import { TimerRunning } from './TimerRunning';
import { SessionReview } from './SessionReview';
export function TimerSheet() {
  const {
    timerSheetOpen,
    setTimerSheetOpen,
    pendingTarget,
    confirmTimerConflict,
    cancelTimerConflict
  } = useUi();
  const {
    timer,
    activityLabel
  } = useAppState();
  const close = () => {
    setTimerSheetOpen(false);
    cancelTimerConflict();
  };
  let title = 'Časovnik';
  let subtitle: string | undefined = 'Izberi nalogo ali vpiši prosto dejavnost';
  let body: React.ReactNode = <TimerPicker data-id="element-1141" data-mp="3raknzvf83w79" />;
  if (pendingTarget && timer) {
    title = 'Končaj trenutnega in začni novega?';
    subtitle = 'En član ima lahko en aktiven časovnik.';
    body = <div className="space-y-4" data-id="element-1142" data-mp="46e9yf65ottl">
        <p className="text-sm" data-id="element-1143" data-mp="438ln25cpvyx">
          Časovnik za <b data-id="element-1144" data-mp="1lyu26qbhhzh9">{activityLabel(timer.target)}</b> {timer.status === 'review' ? 'čaka na pregled seje' : 'še teče'}.
          Če nadaljuješ, se ta seja shrani v dnevnik časa in začne se <b data-id="element-1145" data-mp="1vw87btryj1u9">{activityLabel(pendingTarget)}</b>.
        </p>
        <div className="grid grid-cols-2 gap-2" data-id="element-1146" data-mp="1vunce31qdgvv">
          <Button variant="secondary" onClick={cancelTimerConflict} data-id="element-1147" data-mp="20vuh1t8ktzyb">
            Prekliči
          </Button>
          <Button onClick={confirmTimerConflict} data-id="element-1148" data-mp="24xofduvaurvb">Shrani in začni</Button>
        </div>
      </div>;
  } else if (timer?.status === 'review') {
    title = 'Pregled seje';
    subtitle = activityLabel(timer.target);
    body = <SessionReview key={timer.sessionId} data-id="element-1149" data-mp="2eo0v99s65wv4" />;
  } else if (timer) {
    title = activityLabel(timer.target);
    subtitle = timer.target.templateId ? 'Časovnik naloge' : 'Prosta dejavnost – brez točk';
    body = <TimerRunning data-id="element-1150" data-mp="2omgp3kikzk8b" />;
  }
  return <Sheet open={timerSheetOpen} onClose={close} title={title} subtitle={subtitle} data-id="element-1151" data-mp="2smh2d1ty1pds">
      {body}
    </Sheet>;
}